import React from "react";
import Helmet from "react-helmet";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import ImpressumComponent from "../components/Impressum/Impressum";
import logo from "../img/logo.svg";
import config from "../../data/SiteConfig";

class Impressum extends React.Component {
  render() {
    return (
      <div>
        <div className="pagetype-contact site-wrapper">
          <Helmet title={config.siteTitle} />
          <Header headerImage={logo} />
          <ImpressumComponent />
          <Footer config={config} />
        </div>
      </div>
    );
  }
}

export default Impressum;



// WEBPACK FOOTER //
// ./src/pages/impressum.jsx